import { Injectable } from '@angular/core';
import { GenericConfig }  from '@signature-it/ngx-generic/config';
import { FccDTO, CngDataDTO, CngProductDTO }  from '@signature-it/ngx-generic/models';
import { ProductFullSolrDTO } from '@signature-it/ngx-catalogue/models';
import { SolrProductService } from './solr-product.service'

declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class CngProductService {

    constructor(protected solrProductService: SolrProductService) {
    }


	getProduct(cngProductId: number, cngData: CngDataDTO)  {
        return new Promise((resolve) => {
            this.solrProductService
                .getSolrByProductCode(cngData.getPcc())
                .subscribe((product: ProductFullSolrDTO) => {
                     if (product) {
						 cngData.fetchProduct(cngProductId, product.product_id_i);
                         resolve(cngData);
                     }
                });
        });
    }
}
